(function ($) {
    'use strict';

    var SELECTOR = '[data-cart]';

    var API_URL = '/:language/api/cart';

    var $html = $('html');

    var Cart = {};

    Cart.GtmTrackPurchase = function (data) {
        var dataLayer = window.dataLayer;
        if (!dataLayer) return;

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: data.transaction_id,
                value: parseFloat(data.value),
                currency: "CAD",
                items: data.items
            }
        });
    };

    Cart.getApiUrl = function (urlPath) {
        var lang = $html.attr('lang');
        return location.href.replace(location.pathname, "/" + lang + "/api/cart/" + urlPath);
        // return API_URL.replace(/:language/g, $html.attr('lang'));
    };

    Cart.form2Json = function (form) {
        var result = {};
        var elementValues = form.serializeArray();
        $.each(elementValues, function () {
            // si textarea alors ...
            // check if value then use innerText/innerHtml
            if (result[this.name]) {
                if (!result[this.name].push) {
                    result[this.name] = [result[this.name]];
                }
                result[this.name].push(this.value || '');
            } else {
                result[this.name] = this.value || '';
            }
        });
        return result;
    };

    Cart.onChangeFormField = function (event) {
        if (event.isTrigger) {
            // $(this).attr('value', $(this).val());
            return true;
        }

        event.preventDefault();
        event.stopPropagation();

        var $cart = $(this).closest(SELECTOR);

        $cart.trigger('update.cart');
    }

    Cart.onUpdateCart = function (event) {
        event.preventDefault();

        var $cart = $(this);

        if ($cart.data('async-state')) {
            return;
        }

        Cart.enableGlassPanel();

        // make sure no input has the focus
        var focusedInfo = null;
        var currentFocus = $(':focus');
        currentFocus.blur();
        setTimeout(function() {
            currentFocus = $(':focus');
            // make sure no input has the focus
            currentFocus.blur();
            var focused = currentFocus[0];
            if (focused) {
                focusedInfo = { id: focused.id, name: focused.name };
            }
            currentFocus.closest('form').find('input').prop('disabled', true);
            currentFocus.closest('form').find('input').addClass("glassfield");
        }, 0);


        $cart.data('async-state', 'loading');
        $cart.addClass('is-loading');

        // Get the focused element:
        var formData = Cart.form2Json($cart);
        $.ajax(Cart.getApiUrl( $cart.data("cart-url")), {
            method: 'POST',
            data: formData,
            dataType: "json"
        }).done(function (recvdata) {
            if (!recvdata.ok) {
                console.error('Unknown error');
                return;
            }

            recvdata.htmlReplace.forEach(function (action) {
                $(action.selector)[0][action.method] = action.content;
            });

            if (focusedInfo) {
                var selector = "";
                if (focusedInfo.id) {
                    selector += "#" + focusedInfo.id;
                }
                if (focusedInfo.name) {
                    selector += "[name=\"" + focusedInfo.name + "\"]";
                }
                $(selector).focus();
                $(selector).select();
                $(selector).closest('form').find('input').prop('disabled', false);
                $(selector).closest('form').find('input').removeClass("glassfield");
            }
        }).fail(function (jqXhr, textStatus) {
            console.error(textStatus);
        }).always(function () {
            $cart.removeClass('is-loading');
            $cart.data('async-state', null);
            Cart.disableGlassPanel();
        });
    }

    Cart.onClickPay = function (event) {
        event.preventDefault();
        event.stopPropagation();

        var $cart = $(this).closest(SELECTOR);

        if ($cart.data('async-state')) {
            return;
        }

        Cart.enableGlassPanel();

        $cart.data('async-state', 'loading');
        $cart.addClass('is-loading');

        var formData = Cart.form2Json($cart);
        $.ajax(Cart.getApiUrl("pay"), {
            method: 'POST',
            data: formData,
            dataType: "json"
        }).done(function (recvdata) {
            if( recvdata.htmlReplace){
                recvdata.htmlReplace.forEach(function (action) {
                    $(action.selector)[0][action.method] = action.content;
                });
            }
            if (!recvdata.ok) {
                var errorDiv = $(document.createElement('div'))
                errorDiv.append(recvdata.errorMessage);
                $("body").append(errorDiv.children().first()) ;
                $("#messageModal").css("display", "block");
                $("#messageModal").removeClass("fade");
                $("#messageModal").find("[data-btn-close]").on('click.message.error', function(){
                    $("#messageModal").css("display", "none");
                });
                return;
            } else {
                if(typeof recvdata.gtm !== 'undefined') {
                    Cart.GtmTrackPurchase(recvdata.gtm);
                }
            }
            if( recvdata.redirect ){
                location.href = recvdata.redirect;
            }
        }).fail(function (jqXhr, textStatus) {
            console.error(textStatus);
        }).always(function () {
            $cart.removeClass('is-loading');
            $cart.data('async-state', null);
            Cart.disableGlassPanel();
        });
    }

    Cart.onClickCancel = function (event) {
        event.preventDefault();
        event.stopPropagation();

        var $cart = $(this).closest(SELECTOR);

        if ($cart.data('async-state')) {
            return;
        }

        $cart.data('async-state', 'loading');
        $cart.addClass('is-loading');

        var formData = Cart.form2Json($cart);
        $.ajax(Cart.getApiUrl("cancel"), {
            method: 'POST',
            data: formData,
            dataType: "json"
        }).done(function (recvdata) {
            if (!recvdata.ok) {
                console.error('Unknown error');
                return;
            }
            location.href = recvdata.redirect;
        }).fail(function (jqXhr, textStatus) {
            console.error(textStatus);
        }).always(function () {
            $cart.removeClass('is-loading');
            $cart.data('async-state', null);
        });
    }

    Cart.enableGlassPanel = function(){
        $(".glasspanel").removeClass("disabled");
        $(".glasspanel").addClass("enabled");
    }
    Cart.disableGlassPanel = function(){
        $(".glasspanel").removeClass("enabled");
        $(".glasspanel").addClass("disabled");
    }

    var $body = $('body');

    $(document).ready(function () {
        $body.on('change.cart', SELECTOR + ' [data-cart-field]', Cart.onChangeFormField);

        $body.on('click.cart', SELECTOR + ' [data-cart-pay]', Cart.onClickPay);

        $body.on('click.cart', SELECTOR + ' [data-cart-cancel]', Cart.onClickCancel);

        $body.on('update.cart', SELECTOR, Cart.onUpdateCart);

    })
})(require('jquery'));
